<div [attr.id]="id" class="dashboard-card" [ngClass]="isCardType">
    <div class="dashboard-card__header">
        <div class="dashboard-card__icon" [ngClass]="iconClass">
            <img [src]="iconSrc" alt="" />
        </div>
        <div class="dashboard-card__header-actions">
            @if(isButtonLabel){<button type="button" [ngClass]="buttonClass" (click)="onButtonClick()">{{ buttonLabel }}</button>}
            @if(anchorIconSrc){<a
               href="#"
               [attr.aria-disabled]="isAnchorDisabled"
               [ngClass]="anchorClass"
               (click)="onAnchorClick($event)"
               [ngbPopover]="showPopover ? popoverContent : null"
               [triggers]="popoverTriggers"
               [placement]="popoverPlacement">
               <img [src]="anchorIconSrc" alt="" />
            </a>}
        </div>
    </div>
    <div class="dashboard-card__body">
        <h6 class="card-title">{{ cardTitle }}</h6>
        <div class="dashboard-card__body-info">
            <h6 class="dashboard-card__body-items">@if(activeItems1){<span class="active-items">{{ activeItems1 }}</span>}{{'claimants' | translate}}</h6>
            <h6 class="dashboard-card__body-items">@if(activeItems2){<span class="active-items">{{ activeItems2 }}</span>}{{'items' | translate}}</h6>
        </div>
    </div>
</div>